import script from "./DrawingToolModeControls3d.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingToolModeControls3d.vue?vue&type=script&setup=true&lang=js"

import "./DrawingToolModeControls3d.vue?vue&type=style&index=0&id=2d935425&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d935425"]])

export default __exports__